var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trainManage"},[_c('el-tabs',{staticClass:"tabs-full",attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"训练管理","name":"trainAdmin"}},[_c('trainAdminData')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }